/**
 * Test whether or not a value is defined. Identical to (typeof value !== 'undefined').
 * @param value - The value to evaluate.
 */
export default function defined<T>(value: T): value is Exclude<T, undefined> {
    return value !== undefined;
}
